'use client';

import { contentfulLoader } from './contentful-loader';

import Image, { ImageProps } from 'next/image';

type Props = Omit<ImageProps, 'loader'>;

export const ContentfulImage = (props: Props) => <Image {...props} loader={contentfulLoader} />;
